import React from 'react';
import { Box } from '@mui/material';

export function PriceTabLayout({ children }: { readonly children: React.ReactNode }) {
  return <Box sx={{ minHeight: 0, minWidth: 0, width: '100%', flex: 1, display: 'flex' }}>{children}</Box>;
}
